export class Franchise {
    code: string;
    name: string;

    constructor(){
        this.code = "";
        this.name = "";
    }
}